module.exports = __webpack_public_path__ + "static/media/registerAppImg.7ee01ddd.png";